import React from 'react'

import Heading from '../../../../designSystem/Heading'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import {CustomInputSelect, WrapperSelector} from '../commonStyles'

import {CurrencyType} from '@daedalus/core/src/localization/types/CurrencyType'

type Props = {
  /** List of currencies to be displayed */
  currenciesList: CurrencyType[]
  /** The currently selected value */
  currentCurrency: string
  /** The callback for when a currency is selected. The new currency code will be passed. */
  onChangeCurrency: (code: string) => void
  /** List of currencies to be highlighted and shown first. */
  popularCurrenciesList: CurrencyType[]
}

const MobileCurrencySelector = ({
  currenciesList,
  currentCurrency,
  onChangeCurrency,
  popularCurrenciesList
}: Props) => {
  const handleChange = (value: string) => {
    onChangeCurrency(value)
  }

  const renderOption = (currency: CurrencyType) => (
    <option key={currency.code} value={currency.code}>
      {currency.displayName} ({currency.code})
    </option>
  )

  return (
    <WrapperSelector>
      <Heading appearance="title3" marginBottomSize="s000">
        <FormattedMessageWrapper id="currencyLabel" defaultMessage="Currency" />
      </Heading>

      <Heading appearance="title3" marginBottomSize="s000">
        {currentCurrency?.toUpperCase()}
      </Heading>

      <CustomInputSelect
        id="selectCurrency"
        name="selectCurrency"
        data-id="SelectCurrency"
        value={currentCurrency}
        onChange={event => handleChange(event.target.value)}
      >
        <optgroup>
          {popularCurrenciesList.map(currency => renderOption(currency))}
        </optgroup>
        <optgroup label="-----------">
          {currenciesList.map(currency => renderOption(currency))}
        </optgroup>
      </CustomInputSelect>
    </WrapperSelector>
  )
}

export default MobileCurrencySelector
